import { TfiHeadphoneAlt } from "react-icons/tfi";
import {
  MdOutlineLocationOn,
  MdOutlinePayment,
  MdOutlineArrowForwardIos,
  MdOutlineArrowBackIos,
  MdOutlineArrowRight,
  MdArrowForwardIos,
  MdOutlineStarHalf,
  MdArrowBackIosNew,
  MdWavingHand,
  MdOutlineKeyboardArrowRight,
  MdLocationPin,
} from "react-icons/md";
import { PiNotepadLight, PiHandCoins } from "react-icons/pi";
import {
  BsCart3,
  BsNewspaper,
  BsShieldCheck,
  BsFacebook,
  BsYoutube,
  BsFillTriangleFill,
  BsFillHouseFill,
} from "react-icons/bs";
import {
  AiOutlineUser,
  AiFillStar,
  AiOutlineStar,
  AiFillInstagram,
  AiFillTwitterCircle,
  AiOutlineControl,
  AiOutlineHeart,
  AiFillHeart,
} from "react-icons/ai";
import { TiTags } from "react-icons/ti";
import { RxVideo } from "react-icons/rx";
import { BiSearch, BiLogOut, BiSolidDownArrow, BiTrash } from "react-icons/bi";
import { ImMinus } from "react-icons/im";
import { FaQuestionCircle, FaListUl, FaTimes } from "react-icons/fa";
import { RiBillLine } from "react-icons/ri";
import { LuUserCog } from "react-icons/lu";
import { GiCheckMark } from "react-icons/gi";
const icons = {
  TfiHeadphoneAlt,
  MdOutlineLocationOn,
  PiNotepadLight,
  BsCart3,
  AiOutlineUser,
  TiTags,
  BsNewspaper,
  RxVideo,
  MdOutlinePayment,
  PiHandCoins,
  FaQuestionCircle,
  BsShieldCheck,
  BiSearch,
  FaListUl,
  ImMinus,
  MdOutlineArrowForwardIos,
  MdOutlineArrowBackIos,
  MdOutlineArrowRight,
  MdArrowForwardIos,
  AiFillStar,
  AiOutlineStar,
  BsYoutube,
  MdOutlineStarHalf,
  BsFacebook,
  AiFillInstagram,
  AiFillTwitterCircle,
  MdArrowBackIosNew,
  BsFillTriangleFill,
  MdWavingHand,
  RiBillLine,
  LuUserCog,
  BiLogOut,
  MdOutlineKeyboardArrowRight,
  BsFillHouseFill,
  GiCheckMark,
  BiSolidDownArrow,
  FaTimes,
  AiOutlineControl,
  AiOutlineHeart,
  AiFillHeart,
  BiTrash,
  MdLocationPin,
};

export default icons;
